// extracted by mini-css-extract-plugin
module.exports = {"familyBrand":"styles_familyBrand__1nRxH","brands":"styles_brands__2d_NR","subtitle":"styles_subtitle__2FNC-","groupBrands":"styles_groupBrands__2qCO3"};